import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface SettingsPageHeaderProps {
  /** Current page title (e.g. "Role Management") */
  title: string;
  /** Settings link path - defaults to /settings or /company/:id/settings */
  settingsPath: string;
  /** Optional action buttons (e.g. Add Role, Add User) */
  action?: React.ReactNode;
}

const SettingsPageHeader: React.FC<SettingsPageHeaderProps> = ({ title, settingsPath, action }) => {
  const { t } = useTranslation('components', { keyPrefix: 'settingsPageHeader' });

  return (
    <div className="settings-page-header an-settings-header d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3 an-settings-page">
      <div>
        <nav aria-label={t('breadcrumbLabel')}>
          <ol className="breadcrumb mb-2">
            <li className="breadcrumb-item">
              <Link to={settingsPath}>{t('settings')}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">{title}</li>
          </ol>
        </nav>
        <h2 className="an-page-title mb-0">{title}</h2>
      </div>
      {action && (
        <div className="d-flex gap-2 flex-wrap justify-content-end">
          {action}
        </div>
      )}
    </div>
  );
};

export default SettingsPageHeader;
